import PropTypes from 'prop-types';

import { Box, Heading, Icon, Modal, Paragraph } from '@zillow/constellation-10';
import { IconWarningOutline } from '@zillow/constellation-icons';

const propTypes = { close: PropTypes.func.isRequired };
const defaultProps = {};

const SecurityDepositUpdateFailureModal = ({ close }) => {
  const body = (
    <>
      <Box css={{ display: 'flex', alignItems: 'center', flexDirection: 'column', marginBottom: '400' }}>
        <Icon size="xl" css={{ color: 'icon.accent.brand.hero', marginBlock: '200' }} render={<IconWarningOutline />} />
        <Heading level={4}>A problem occurred</Heading>
      </Box>
      <Paragraph>
        We are not able to update the security deposit currently. Please try again later or contact customer support.
      </Paragraph>
    </>
  );

  return (
    <Modal
      open={true}
      onOpenChange={(open) => !open && close()}
      header={<Heading level={2}>A problem occurred</Heading>}
      body={<div data-testid="SecurityDepositUpdateFailureModal">{body}</div>}
      useDismissProps={{
        escapeKey: true,
        outsidePress: false,
      }}
      size={{ base: 'fullScreen', md: 'sm' }}
    />
  );
};

SecurityDepositUpdateFailureModal.propTypes = propTypes;
SecurityDepositUpdateFailureModal.defaultProps = defaultProps;

export default SecurityDepositUpdateFailureModal;
